import { isRef as z, isReactive as U, isProxy as W, toRaw as Y, defineComponent as A, inject as E, computed as N, watch as x, resolveComponent as J, openBlock as f, createElementBlock as V, normalizeStyle as K, createElementVNode as Q, createBlock as L, resolveDynamicComponent as Z, unref as k, createVNode as F, createCommentVNode as G, Fragment as q, renderList as H, withDirectives as ee, withModifiers as _, vShow as te, ref as I, provide as D, onMounted as oe, onUnmounted as re } from "vue";
const O = (v) => {
  const o = [], n = (i, d = []) => {
    o.push({
      ...i,
      __vue_dnd_tree_ancestors: d
    });
    for (const u of i.children)
      n(u, [...d, i.id]);
  };
  return v.forEach((i) => {
    n(i);
  }), o;
};
function ne(v) {
  const o = (n) => Array.isArray(n) ? n.map((i) => o(i)) : z(n) || U(n) || W(n) ? o(Y(n)) : n && typeof n == "object" ? Object.keys(n).reduce((i, d) => (i[d] = o(n[d]), i), {}) : n;
  return o(v);
}
const de = (v, o, n) => Math.min(Math.max(v, o), n), ae = {
  key: 0,
  style: { display: "flex", "flex-direction": "row", "align-items": "center", opacity: "0.3", "pointer-events": "none" }
}, R = /* @__PURE__ */ A({
  __name: "TreeNode",
  props: {
    item: {},
    component: {},
    ancestors: {},
    depth: {},
    deltaX: {},
    isGhost: { type: Boolean },
    locked: { type: Boolean }
  },
  setup(v) {
    var M, B;
    const o = v;
    if (!o.item)
      throw new Error("item is required");
    if (typeof ((M = o.item) == null ? void 0 : M.id) != "string" || o.item.id === "")
      throw new Error("item.id is required");
    if (!Array.isArray((B = o.item) == null ? void 0 : B.children))
      throw new Error("item.children array is required");
    if (!("expanded" in o.item))
      throw new Error("item.expanded is required");
    if (!o.component)
      throw new Error("component is required");
    const n = E("setExpanded", () => {
      throw new Error("setExpanded has not been provided");
    }), i = (e) => {
      n(e, o.item.id);
    }, d = E("dropTarget"), u = E("dragItem"), y = E("dragstart"), j = (e, l, s) => {
      if (y === void 0)
        throw new Error("VueTreeDnd has not been provided");
      y(e, l, s);
    }, T = E("dragover"), C = (e, l) => {
      if (T === void 0)
        throw new Error("VueTreeDnd has not been provided");
      T(e, l);
    }, p = N(() => {
      if ((u == null ? void 0 : u.value) == null)
        return [];
      const e = u.value.id;
      if (o.item.children.filter((s) => s.id !== e).length > 0 && o.item.expanded)
        return [{ id: e, targetId: o.item.id, position: "FIRST_CHILD", ghostIndent: o.depth + 1 }];
      const l = (s) => o.depth - (o.ancestors.length - s);
      return [
        ...o.ancestors.map((s, S) => ({
          id: e,
          targetId: s,
          position: "RIGHT",
          ghostIndent: l(S)
        })),
        { id: e, targetId: o.item.id, position: "RIGHT", ghostIndent: o.depth },
        { id: e, targetId: o.item.id, position: "LAST_CHILD", ghostIndent: o.depth + 1 }
      ];
    }), m = N(() => {
      const e = Math.min(...p.value.map((s) => s.ghostIndent)), l = Math.max(...p.value.map((s) => s.ghostIndent));
      return de(o.deltaX, e, l);
    }), X = E("setDropProposal"), g = (e) => {
      if (X === void 0)
        throw new Error("VueTreeDnd has not been provided");
      X(e);
    };
    x([d, p, m], () => {
      if (!(d === void 0 || (d == null ? void 0 : d.value) === null) && d.value === o.item.id) {
        const e = p.value.find((l) => l.ghostIndent === m.value);
        if (e == null)
          throw new Error(`Could not find impliedMoveMutation for ghostIndent ${m.value}`);
        g(e);
      }
    });
    const w = {
      position: "absolute",
      opacity: 0,
      pointerEvents: "none"
    }, b = N(() => {
      var e;
      return ((e = u == null ? void 0 : u.value) == null ? void 0 : e.id) === o.item.id && !o.isGhost ? w : {};
    });
    return (e, l) => {
      var S;
      const s = J("TreeNode", !0);
      return f(), V("a", {
        href: "javascript:;",
        style: K([{ color: "inherit", "text-decoration": "none" }, b.value])
      }, [
        Q("div", {
          style: { display: "flex", "flex-direction": "row", "align-items": "center" },
          onDragover: l[0] || (l[0] = (t) => C(t, e.item.id))
        }, [
          (f(), L(Z(e.component), {
            item: e.item,
            depth: e.depth,
            expanded: e.item.expanded,
            onSetExpanded: i
          }, null, 40, ["item", "depth", "expanded"]))
        ], 32),
        k(d) === e.item.id && !e.isGhost && k(u) !== void 0 ? (f(), V("div", ae, [
          F(s, {
            item: k(u),
            component: e.component,
            ancestors: [],
            "drop-target": k(d),
            depth: m.value,
            "delta-x": e.deltaX,
            "is-ghost": !0,
            locked: e.locked
          }, null, 8, ["item", "component", "drop-target", "depth", "delta-x", "locked"])
        ])) : G("", !0),
        (f(!0), V(q, null, H(((S = e.item) == null ? void 0 : S.children) || [], (t, r) => {
          var a, c, h;
          return ee((f(), L(s, {
            key: t.id,
            item: t,
            component: e.component,
            ancestors: r === e.item.children.length - 1 || r === e.item.children.length - 2 && ((a = k(u)) == null ? void 0 : a.id) === ((h = (c = e.item) == null ? void 0 : c.children[e.item.children.length - 1]) == null ? void 0 : h.id) ? [...e.ancestors, e.item.id] : [],
            "drop-target": k(d),
            depth: e.depth + 1,
            "delta-x": e.deltaX,
            "is-ghost": e.isGhost,
            locked: e.locked,
            draggable: !e.locked,
            onDragstart: _(($) => j($, t.id, e.depth + 1), ["stop"])
          }, null, 8, ["item", "component", "ancestors", "drop-target", "depth", "delta-x", "is-ghost", "locked", "draggable", "onDragstart"])), [
            [te, e.item.expanded]
          ]);
        }), 128))
      ], 4);
    };
  }
}), ie = {
  key: 0,
  style: { display: "flex", "flex-direction": "row", "align-items": "center", opacity: "0.3", "pointer-events": "none" }
}, P = "__vue-dnd-tree-root__", le = /* @__PURE__ */ A({
  __name: "VueTreeDnd",
  props: {
    modelValue: {},
    component: {},
    locked: { type: Boolean }
  },
  emits: ["move", "update:modelValue"],
  setup(v, { emit: o }) {
    const n = v, i = I([]), d = I([]), u = (t) => i.value.find((r) => r.id === t);
    x(() => n.modelValue, () => {
      i.value = O(n.modelValue), d.value = i.value.map(({ id: t }) => t);
    }, { immediate: !0 }), D("setExpanded", (t, r) => {
      const a = structuredClone(ne(n.modelValue)), c = (h) => {
        h.id === r && (h.expanded = t), h.children !== void 0 && h.children.forEach(c);
      };
      a.forEach(c), o("update:modelValue", a);
    });
    const y = (t) => {
      const r = d.value.findIndex((a) => a === t);
      return r === 0 ? P : d.value[r - 1];
    }, j = (t) => {
      if (t === P)
        return !1;
      const r = i.value.find((c) => c.id === t);
      if (r === void 0)
        throw new Error(`targetId ${t} not found in flatTreeNodes`);
      return r.__vue_dnd_tree_ancestors.some((c) => {
        var h;
        return !(((h = u(c)) == null ? void 0 : h.expanded) ?? !1);
      });
    }, T = I(0), C = (t) => {
      if (t.preventDefault(), l.value === null)
        throw new Error("VueTreeDnd has not correctly set dataTransfer data (missing)");
      const { initialX: r, initialDepth: a } = l.value, c = Math.round((+t.clientX - r) / 20);
      T.value = a + c;
    };
    oe(() => {
      document.addEventListener("dragover", C);
    }), re(() => {
      document.removeEventListener("dragover", C);
    });
    const p = I(null), m = N(() => i.value.find((t) => t.id === p.value));
    D("dragItem", m);
    const X = N(() => m.value === void 0 ? /* @__PURE__ */ new Set() : new Set(O([m.value]).map((t) => t.id))), g = I(null), w = (t) => {
      if (X.value.has(t) || j(t)) {
        w(y(t));
        return;
      }
      g.value = t;
    };
    D("dropTarget", g), D("setDropTarget", w);
    const b = I(null), M = (t) => {
      b.value = t;
    };
    D("setDropProposal", M), x(g, () => {
      if (g.value === P) {
        if (p.value === null)
          throw new Error("dragItemId.value is null");
        M({
          id: p.value,
          targetId: n.modelValue[0].id,
          position: "LEFT",
          ghostIndent: 0
        });
      }
    });
    const B = () => {
      if (b.value == null)
        return;
      g.value = null, p.value = null;
      const { ghostIndent: t, ...r } = b.value;
      r.id !== r.targetId && o("move", r);
    }, e = new Image(), l = I(null), s = (t, r, a) => {
      t.dataTransfer !== null && (t.dataTransfer.dropEffect = "none", t.dataTransfer.effectAllowed = "none", t.dataTransfer.setDragImage(e, 0, 0)), setTimeout(() => {
        p.value = r, l.value = {
          initialX: t.clientX,
          initialDepth: a
        }, w(y(r));
      }, 0);
    };
    return D("dragstart", s), D("dragover", (t, r) => {
      t.preventDefault();
      const a = y(r);
      if (p.value === r) {
        w(a);
        return;
      }
      w(t.offsetY < t.target.clientHeight / 2 ? a : r);
    }), (t, r) => (f(), V("div", { onDragend: B }, [
      g.value === P && m.value !== void 0 ? (f(), V("div", ie, [
        F(R, {
          item: m.value,
          component: t.component,
          ancestors: [],
          depth: 0,
          "delta-x": T.value,
          "is-ghost": !0,
          locked: t.locked
        }, null, 8, ["item", "component", "delta-x", "locked"])
      ])) : G("", !0),
      (f(!0), V(q, null, H(t.modelValue || [], (a) => (f(), L(R, {
        key: a.id,
        item: a,
        component: t.component,
        ancestors: [],
        depth: 0,
        "drop-target": g.value,
        "delta-x": T.value,
        "is-ghost": !1,
        locked: t.locked,
        draggable: !t.locked,
        onDragstart: _((c) => s(c, a.id, 0), ["stop"])
      }, null, 8, ["item", "component", "drop-target", "delta-x", "locked", "draggable", "onDragstart"]))), 128))
    ], 32));
  }
});
export {
  le as default
};
